/**
 * Feedback submission service using Supabase
 * NEW file — does not modify any existing data services
 */

import { isSupabaseConfigured, supabase } from "../supabaseClient";

export type FeedbackCategory = "bug" | "feature" | "general";

export interface FeedbackPayload {
  category: FeedbackCategory;
  message: string;
  diagramId?: string | null;
}

export interface FeedbackRecord {
  id: string;
  user_id: string | null;
  diagram_id: string | null;
  category: string;
  message: string;
  user_agent: string | null;
  page_url: string | null;
  status: string;
  created_at: string;
}

/**
 * Submit a feedback entry to the `feedback` table.
 * Automatically attaches user_id (from session), user_agent, and page_url.
 */
export const submitFeedback = async (
  payload: FeedbackPayload,
): Promise<FeedbackRecord> => {
  if (!isSupabaseConfigured || !supabase) {
    throw new Error("Supabase not configured");
  }

  const {
    data: { user },
  } = await supabase.auth.getUser();

  if (!user) {
    throw new Error("User not authenticated");
  }

  const { data, error } = await supabase
    .from("feedback")
    .insert({
      user_id: user.id,
      diagram_id: payload.diagramId || null,
      category: payload.category,
      message: payload.message,
      user_agent: navigator.userAgent,
      page_url: window.location.href,
    })
    .select()
    .single();

  if (error) {
    console.error("[FeedbackService] Failed to submit feedback:", error);
    throw error;
  }

  return data;
};
